import Quill from 'quill';
import { inlineblotOrder } from './inline-blot-order';
const Inline = Quill.import('blots/inline');
const BLOT_NAME = 'notForTraining';
class NotForTrainingBlot extends Inline {
    static create(value) {
        if (!inlineblotOrder.includes(BLOT_NAME)) {
            throw new Error('Blot is not listed in inline blot order');
        }
        const node = super.create(value);
        node.dataset.notForTraining = value;
        return node;
    }
    static formats(domNode) {
        var _a;
        return (_a = domNode.dataset.notForTraining) !== null && _a !== void 0 ? _a : null;
    }
    format(name, value) {
        if (name === BLOT_NAME) {
            this.domNode.dataset.notForTraining = value !== null && value !== void 0 ? value : null;
        }
        else {
            super.format(name, value);
        }
    }
    formats() {
        const formats = super.formats();
        formats[BLOT_NAME] = NotForTrainingBlot.formats(this.domNode);
        return formats;
    }
    attach() {
        if (this.parent != null) {
            this.scroll = this.parent.scroll;
        }
    }
}
NotForTrainingBlot.blotName = BLOT_NAME;
export default NotForTrainingBlot;
NotForTrainingBlot.blotName = BLOT_NAME;
NotForTrainingBlot.tagName = 'span';
